import { render, staticRenderFns } from "./Pavilions.vue?vue&type=template&id=6f860ef6&scoped=true&"
import script from "./Pavilions.vue?vue&type=script&lang=js&"
export * from "./Pavilions.vue?vue&type=script&lang=js&"
import style0 from "./Pavilions.vue?vue&type=style&index=0&id=6f860ef6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f860ef6",
  null
  
)

export default component.exports